var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photography"},[_c('banner',{attrs:{"part-id":"photography"}}),_c('AntiShake'),_c('WideAngle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }